import { RepositoryFactory } from "../../api/RepositoryFactory";
import ApiErrorHandler from "@/_helpers/apiErrorHandler.js";

const DeviceRepository = RepositoryFactory.get("devices");

export const devices = {
  namespaced: true,
  state: {
    devices: [],
    device: {},
    pool: [],
    keys: [],
    metas: [],
    status: {
      loading: false,
    },
  },

  actions: {
    async get({ dispatch, commit, rootState }, metaInclude = false) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      var companyId = rootState.users.userCompany.companyId;

      await DeviceRepository.get(user, companyId)
        .then((devices) => {
          if (metaInclude) commit("SET_DEVICES_WITH_META", devices.data);

          commit("SET_DEVICES", devices.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getById({ dispatch, commit, rootState }, deviceId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.getById(user, deviceId)
        .then((devices) => {
          commit("SET_DEVICE", devices.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async create({ dispatch, commit, rootState }, payload) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      var companyId = rootState.users.userCompany.companyId;

      await DeviceRepository.create(user, companyId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async update({ dispatch, commit, rootState }, { deviceId, payload }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.update(user, deviceId, payload)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async delete({ dispatch, commit, rootState }, deviceId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.delete(user, deviceId)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getKeys({ dispatch, commit, rootState }, deviceId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.getKeys(user, deviceId)
        .then((keys) => {
          commit("SET_KEYS", keys.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getPool({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceRepository.getPool(user)
        .then((pool) => {
          commit("SET_POOL", pool.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async setPool({ dispatch, commit, rootState }, { companyId, deviceId }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      if (companyId == null || companyId == undefined)
        companyId = rootState.users.userCompany.companyId;

      await DeviceRepository.setPool(user, companyId, deviceId)
        .then(() => commit("LOADING", false))
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );
    },

    async getMetas({ dispatch, commit, rootState }, deviceId) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      await DeviceRepository.getMetas(user, deviceId)
        .then((data) => {
          commit("SET_META", data.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async deleteMeta({ dispatch, commit, rootState }, deviceMetaId) {
      commit("LOADING", true);
      var user = rootState.users.currentUser;
      await DeviceRepository.deleteMeta(user, deviceMetaId)
        .then(() => {
          commit("LOADING", false);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );
      commit("LOADING", false);
    },

    async createMeta({ dispatch, commit, rootState }, { deviceId, payload }) {
      commit("LOADING", true);
      var user = rootState.users.currentUser;

      await DeviceRepository.createMeta(user, deviceId, payload)
        .then(() => {})
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    SET_POOL(state, pool) {
      state.pool = pool;
    },

    SET_DEVICES(state, devices) {
      state.devices = devices;
    },

    SET_DEVICE(state, device) {
      state.device = device;
    },

    SET_KEYS(state, keys) {
      state.keys = keys;
    },

    SET_META(state, data) {
      state.metas = data;
    },

    SET_DEVICES_WITH_META(state, data) {
      for (let d in data) {
        let result = "";
        for (let j in data[d].deviceMetas)
          result += `${data[d].deviceMetas[j].keyName}: ${data[d].deviceMetas[j].value} `;

        data[d].meta = result;
      }

      state.devices = data;
    },
  },
};
